module.exports = __webpack_public_path__ + "./fonts/amatic-sc-700.ttf";